export const emptyRadioValue = Symbol('mollie-ui-radio');
//# sourceMappingURL=RadioListSymbol.js.map